import React from 'react';
import {useState} from 'react';
import Editor from '@react-page/editor';

import '@react-page/editor/lib/index.css';
import cellPlugins from "./cell_plugins";
import {useSelector} from "react-redux";

const RenderedPageEditor = ({htmlContent, readOnly}) => {
  const [value, setValue] = useState(htmlContent?.json);

  const editorProps = {
    cellPlugins,
    value,
  }

  if (readOnly) {
    editorProps.readOnly = true
  } else {
    editorProps.onChange = (value) => {
      setValue(value)

      if (window.on_page_editor_value_changed) {
        window.on_page_editor_value_changed(value)
      }
    }
  }

  return (
    <Editor {...editorProps}/>
  );
}

const PageEditor = ({htmlContentId, readOnly}) => {
  const htmlContents = useSelector(state => state.htmlContents)
  const htmlContent = htmlContents.find(htmlContent => htmlContent.id === htmlContentId)

  if (!htmlContent) {
    return <div className={"alert alert-danger"}>
      Html Content with id {htmlContentId} not found.
    </div>
  }

  return <RenderedPageEditor readOnly={readOnly} htmlContent={htmlContent}/>
}

export default PageEditor
